export default "__VITE_ASSET__BUYmdDyj__"